<div class="flex flex-row items-center">
  <div class="flex-initial h-2 w-2 rounded-full border border-solid border-[#BDD3EE]"></div>
  <div class="flex-1 h-px bg-[#BDD3EE]"></div>
  <div class="flex-initial h-2 w-2 rounded-full border border-solid border-[#BDD3EE]"></div>
</div>
